import { Box, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";

export function Dashboard() {

  const selectedHub = useSelector(state => state.user.selected_hub)?.[0];
  const dashboardMap = {
    1: process.env.REACT_APP_AMBATTUR_CODE,
    3: process.env.REACT_APP_OMR_CODE,
    4: process.env.REACT_APP_OMR_2_CODE,
    5: process.env.REACT_APP_HIRANDAHALI_CODE,
    6: process.env.REACT_APP_FOOD_FIX_CODE,
  };

  const renderGrafanaDashboard = (selectedHub) => {
    //console.log(dashboardMap)
    const dashboardId = process.env.REACT_APP_GRAFANA_URL + dashboardMap[selectedHub] + '/?theme=light';
    if (!dashboardId) return null;
    //console.log("Grafana URL",process.env.REACT_APP_GRAFANA_URL);
    return (
      <Box
        sx={{
          width: "100%",
          height: "100vh",
          border: "1px solid #ccc",
          overflow: "hidden",
        }}
      >
        <iframe
          src={`${dashboardId}`}
          title={`Grafana Dashboard ${selectedHub}`}
          style={{
            width: "100%",
            height: "100%",
            border: "none",
          }}
        />
      </Box>
    );
  };
  

    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          <>{renderGrafanaDashboard(selectedHub)}</>
        </Box>
    )
}